<template>
	<v-card flat max-width="950px" class="mx-auto transparent">
        <HeadRoot 
            title="Center Admin"
            :length="0"
            btn_txt=""
            btn_to="" />
        
        <div class="mt-2" v-if="user.role.master">
            <v-btn text @click="$router.push('/admin-centers')">
                <v-icon size="14px" color="grey darken-3" class="mr-3">fa-angle-left</v-icon>
                Back to Centers
            </v-btn>
        </div>

        <v-card flat class="transparent" v-if="loaded">
            <v-card-text>
                <div class="headline font-weight-regular primary--text">{{item.name}} Center</div>
                <div class="d-flex align-center body-2 ml-2" v-if="user.role.master">
                    <div class="mr-2">Managed by </div> 
                    <UserAvatar :photo="item.photo" size="28px"/>
                    <div class="ml-1">{{item.director.name}}</div>
                </div>
            </v-card-text>
        </v-card>

        <SendingLoader v-if="!loaded"/>

        <v-tabs v-model="tab" background-color="#FDFDFD">
            <v-tab>Users</v-tab>
            <v-tab>Groups</v-tab>
            <!-- <v-tab>Schedules</v-tab> -->

            <v-tab-item>
                <ListUsers :center="$route.params.id" :editable="true"/>
            </v-tab-item>
            <v-tab-item>
                <ListGroups kind="center" :center="$route.params.id" />
            </v-tab-item>
            <!-- <v-tab-item>
                <ListSchedules :center="$route.params.id" />
            </v-tab-item> -->
        </v-tabs>
	</v-card>
</template>

<script>
import Centers from '@/firebase/centers'
import ListUsers from '@/components/users/List'
import ListGroups from '@/components/groups/List'
import ListSchedules from '@/components/schedules/List'

export default {
    data: () => ({
        loaded: false,
        item: null,
        tab: 0
    }),
    components: {
        ListUsers,
        ListGroups,
        ListSchedules
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            Centers.get(this.$route.params.id)
                    .then(response => {
                        if (response.status === true) {
                            this.item = response.doc.data();
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred, please try again later.'});
                        }
                    });
        }
    }
}
</script>